import queryString from 'qs';

const COLUMN_MAPPINGS = {
    group: 'store_group',
};

const formatDateRange = (dateObj) => {
    if (!dateObj?.startDate) return null;
    const start = dateObj.startDate.format('YYYY-MM-DD');
    const end = (dateObj.endDate || dateObj.startDate).format('YYYY-MM-DD');
    return `(${start},${end})`;
};

const getAuditTrailRequest = (payload) => {
    const {
        dc,
        custGroup,
        groupType,
        parahub,
        dateSellout,
        dateUpload,
        uploadType,
        selloutType,
        status,
        page,
        limit,
        searchQuery,
        sort,
    } = payload || {};

    const data = {
        nama_dc: dc?.map((item) => item?.name).join(',') || null,
        store_group: `[${custGroup?.map((item) => item?.name).join(',')}]` || null,
        group_type: groupType?.name || null,
        customer_id: parahub?.map((item) => item?.id).join(',') || null,
        date_sellout: formatDateRange(dateSellout),
        date_uploaded: formatDateRange(dateUpload),
        upload_type: uploadType?.map((item) => item?.name).join(',') || null,
        sellout_type: selloutType?.name || null,
        status: status?.map((item) => item?.name).join(',') || null,
        page,
        limit,
        search: searchQuery ? `customer_id.${searchQuery},nama_outlet.${searchQuery}` : null,
        sort: sort ? `${COLUMN_MAPPINGS[sort.name] || sort.name}.${sort.type}` : null,
    };

    return queryString.stringify(data, { skipNulls: true });
};

export default getAuditTrailRequest;
